import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    FormControl,
    FormControlLabel,
    MenuItem,
    Select,
    TextField,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Switch from "@material-ui/core/Switch";
import { IsNullOrEmpty } from "../../helpers/utility";
import {
    addBankAccountRequest,
    updateBankAccountRequest,
} from "../../store/shopping/shopping.actions";

export default function ManageBank(props) {
    const dispatch = useDispatch();
    const { mode } = props;
    const [bankName, setBankName] = useState("");
    const [accountName, setAccountName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [isDefault, setDefault] = useState(false);
    const [form, setForm] = useState(false);

    useEffect(() => {
        setBankName(props.item.bankName);
        setAccountName(props.item.accountName);
        setAccountNumber(props.item.accountNumber);
        setDefault(props.item.isDefault);
    }, [props.item]);

    const reset = () => {
        setBankName(props.item.bankName);
        setAccountName(props.item.accountName);
        setAccountNumber(props.item.accountNumber);
        setDefault(props.item.isDefault);
    };

    const validate = () => {
        return (
            !IsNullOrEmpty(bankName) &&
            !IsNullOrEmpty(accountName) &&
            !IsNullOrEmpty(accountNumber)
        );
    };

    const banks = [
        "Affin Bank",
        "Agro Bank",
        "Alliance Bank",
        "Am Bank",
        "Bank Islam",
        "Bank Muamalat",
        "Bank Rakyat",
        "CIMB Bank",
        "Hong Leong Bank",
        "HSBC Bank",
        "Kuwait Finance",
        "Maybank",
        "OCBC Bank",
        "Public Bank",
        "RHB Bank",
        "Standard Chartered Bank",
        "UOB Bank",
    ];

    return (
        <Card elevation={0} className="mt-2">
            <CardHeader
                title={
                    mode === "add" ? "Add Bank Account" : "Edit Bank Account"
                }
                action={<Close onClick={() => props.onClose()} />}
            />
            <CardContent>
                <FormControl variant="outlined" fullWidth>
                    <Select
                        variant="outlined"
                        fullWidth
                        value={bankName}
                        defaultValue={bankName}
                        displayEmpty
                        placeholder="All Time"
                        margin="dense"
                        onChange={(e) => setBankName(e.target.value)}
                        error={IsNullOrEmpty(bankName) && form}
                        helperText={
                            IsNullOrEmpty(bankName) && form
                                ? "Bank name cannot be empty"
                                : ""
                        }
                    >
                        <MenuItem value={undefined}>Select Bank</MenuItem>
                        {banks.map((x) => {
                            return (
                                <MenuItem key={x} value={x}>
                                    {x}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
                <TextField
                    margin="dense"
                    className="mb-2"
                    fullWidth
                    variant="outlined"
                    value={accountName}
                    error={IsNullOrEmpty(accountName) && form}
                    helperText={
                        IsNullOrEmpty(accountName) && form
                            ? "Account name cannot be empty"
                            : ""
                    }
                    onChange={(e) => setAccountName(e.target.value)}
                    placeholder="Account Name"
                />
                <TextField
                    margin="dense"
                    className="mb-2"
                    fullWidth
                    variant="outlined"
                    value={accountNumber}
                    error={IsNullOrEmpty(accountNumber) && form}
                    helperText={
                        IsNullOrEmpty(accountNumber) && form
                            ? "Account # cannot be empty"
                            : ""
                    }
                    onChange={(e) => setAccountNumber(e.target.value)}
                    placeholder="Account Number"
                />
                <FormControlLabel
                    label="Set as default"
                    control={
                        <Switch
                            checked={isDefault}
                            className="mb-2"
                            color={isDefault ? "primary" : "secondary"}
                            onChange={(e) => setDefault(e.target.checked)}
                        />
                    }
                />
            </CardContent>
            <CardActions>
                <Button
                    variant="contained"
                    fullWidth
                    color="secondary"
                    onClick={() => {
                        props.onClose();
                    }}
                >
                    Cancel
                </Button>
                {mode === "edit" ? (
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={() =>
                            validate()
                                ? dispatch(
                                      updateBankAccountRequest({
                                          accountName: accountName,
                                          accountNumber: accountNumber,
                                          bankName: bankName,
                                          status: "Active",
                                          isDefault: isDefault,
                                          _id: props.item._id,
                                      })
                                  )
                                : setForm(true)
                        }
                    >
                        Update
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={() => {
                            validate()
                                ? dispatch(
                                      addBankAccountRequest({
                                          accountName: accountName,
                                          accountNumber: accountNumber,
                                          bankName: bankName,
                                          status: "Active",
                                          isDefault: isDefault ? true : false,
                                      })
                                  )
                                : setForm(true);
                        }}
                    >
                        Add
                    </Button>
                )}
            </CardActions>
        </Card>
    );
}
